import React from 'react';
import styled from 'styled-components';
import { Grid, Col } from '@enso/components';
import { utils } from '@enso/components';
import theme from '../../../theme';

const TestimonialsContainer = styled.section`
  padding: 0px 24px 60px;
  background-color: ${props => props.theme.color.backgroundWhite};

  @media ${utils.device.laptop} {
    padding: 0px 140px 100px;
  }
`;

const Title = styled.h2`
  font-family: ${props => props.theme.font.title};
  font-size: 28px;
  font-weight: bold;
  color: ${props => props.theme.color.textDark};
  margin-bottom: 40px;
  text-align: center;

  @media ${utils.device.laptop} {
    font-size: 36px;
    margin-bottom: 60px;
  }
`;

const OrangeText = styled.span`
  color: #fd5e43;
`;

const LogoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 32px;
  align-items: center;
  justify-items: center;
`;

const LogoImage = styled.img`
  max-width: 100%;
  height: auto;
  opacity: 0.7;
  filter: grayscale(100%);
  transition: opacity 0.2s, filter 0.2s;

  &:hover {
    opacity: 1;
    filter: grayscale(0%);
  }
`;

TestimonialsContainer.defaultProps = { theme };
Title.defaultProps = { theme };

const Testimonials = function() {
  return (
    <TestimonialsContainer>
      <Title>
        Lo que dicen de <OrangeText>nosotros:</OrangeText>
      </Title>
      <LogoGrid>
        <LogoImage src="/images/entrepreneur 2.webp" alt="Entrepreneur" />
        <LogoImage src="/images/economista.webp" alt="El Economista" />
        <LogoImage src="/images/entrepreneur.webp" alt="Entrepreneur" />
        <LogoImage src="/images/reforma.webp" alt="Reforma" />
        <LogoImage src="/images/universal.webp" alt="El Universal" />
      </LogoGrid>
    </TestimonialsContainer>
  );
};

export default Testimonials;
